<template>
  <div>
    <b-field class="ws-field"
             :label="$t('Поиск')">
      <b-taginput
        :data="users.list"
        :loading="isUserFindPending"
        v-model="users.value"
        class="ws-field__control ws-field__control--taginput"
        :placeholder="placeholder"
        :allow-duplicates="false"
        autocomplete
        field="login"
        type="is-info"
        @typing="getUsersList">
        <template slot-scope="props">
          <div class="media">
            <div class="media-left">
              <figure class="image is-48x48">
                <ws-avatar :id="props.option.guid"
                           :name="`${props.option.first.display &&  props.option.first.display } ${props.option.last.display &&  props.option.last.display }`"
                           :size="48" />
              </figure>
            </div>
            <div class="media-content">
            <span v-if="props.option.last.display && props.option.first.display">
                <strong>{{ props.option.last.display }} {{ props.option.first.display }} {{ props.option.middle.display }}</strong> <br>
<!--                <span class="is-size-5">{{ props.option.region.title.display }}</span><br>-->
                <span class="has-text-primary">{{ props.option.email }}</span>
            </span>
            <span v-else>
                <strong>{{ props.option.login }}</strong>
            </span>
            </div>
          </div>
        </template>
        <template slot="empty">{{$t('Пользователь не найден')}}</template>
      </b-taginput>
    </b-field>
    <button type="button" class="ws-button button is-fullwidth"
            :disabled="users.value.length === 0"
            @click="inputUsers"
            v-text="$t('Добавить')">
    </button>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { debounce } from 'debounce'
export default {
  name: 'WsSearchUsers',
  props: {
    placeholder: {
      type: String
    }
  },
  data () {
    return {
      users: {
        list: [],
        value: []
      }
    }
  },
  computed: {
    ...mapState('esatk/users', {
      isUserFindPending: 'isFindPending'
    })
  },
  methods: {
    ...mapActions('esatk/users', {
      findUsers: 'find'
    }),
    ...mapMutations('esatk/users', ['clearAll']),
    inputUsers () {
      this.$emit('input-users', this.users.value)
      this.users.value = []
    },
    getUsersList: debounce(async function (text) {
      const keyword = text
      if (keyword) {
        this.clearAll()
        const users = await this.findUsers({ query: { k: keyword } })
        this.users.list = users && users.length ? users : []
      }
    }, 500)
  }
}
</script>
